import { Component } from '@angular/core';

@Component({
    selector: 'cash-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent {
  checkBrowserLanguage(languages: string[]) {
    const browserLanguage = navigator.languages[0];
    return languages.some(
      (language) =>
        browserLanguage && (browserLanguage ? browserLanguage.indexOf(language) : null) > -1
    );
  }
}
